import { SxProps } from '@mui/system';
import * as S from './Label.styled';

interface IProps {
  label: string;
  required?: boolean;
  disabled?: boolean;
  error?: boolean;
  sx?: SxProps;
  htmlFor?: string;
}

const Label = ({ label, required, ...restProps }: IProps): JSX.Element => {
  return (
    <S.StyledFormLabel {...restProps}>
      {required ? (
        <span className='field_label'>
          {label}
          <span className='asterick'>*</span>
        </span>
      ) : (
        label
      )}
    </S.StyledFormLabel>
  );
};

export default Label;
